// 배송 사진에 촬영 시각을 남기기 위한 유틸.
// 사진 자체에 시각을 새겨(워터마크) 증빙력을 높이고, 같은 시각을 서버에도
// captured_at으로 함께 보낸다. 표시의 기준은 서버에 저장된 captured_at이고,
// 워터마크는 이미지 파일만 따로 봤을 때를 위한 것이다.

const seoulStampFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Seoul",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

function seoulParts(date) {
  const parts = {};
  for (const part of seoulStampFormatter.formatToParts(date)) {
    parts[part.type] = part.value;
  }
  return parts;
}

/**
 * 화면과 워터마크에 쓸 한국시간 문자열 (YYYY-MM-DD HH:mm:ss)
 */
export function formatSeoulTimestamp(date = new Date()) {
  const p = seoulParts(date);
  // en-CA는 24시 표기에서 자정을 "24"로 주는 런타임이 있어 "00"으로 맞춘다
  const hour = p.hour === "24" ? "00" : p.hour;
  return `${p.year}-${p.month}-${p.day} ${hour}:${p.minute}:${p.second}`;
}

/**
 * 서버로 보낼 촬영 시각. KST 오프셋을 명시한 ISO 8601 문자열.
 * 단말 표준시가 무엇이든 서버가 같은 절대 시각으로 해석한다.
 */
export function toSeoulIsoString(date = new Date()) {
  return `${formatSeoulTimestamp(date).replace(" ", "T")}+09:00`;
}

/**
 * 파일명에 쓸 촬영 시각 (YYYYMMDD_HHmmss)
 */
export function toFileNameTimestamp(date = new Date()) {
  const p = seoulParts(date);
  const hour = p.hour === "24" ? "00" : p.hour;
  return `${p.year}${p.month}${p.day}_${hour}${p.minute}${p.second}`;
}

/**
 * 캔버스 우측 하단에 촬영 시각을 새긴다.
 * 밝은 배경에서도 읽히도록 반투명 검은 박스 위에 흰 글씨로 그린다.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {HTMLCanvasElement} canvas
 * @param {Date} date - 촬영 시각
 */
export function drawTimestampWatermark(ctx, canvas, date = new Date()) {
  const text = formatSeoulTimestamp(date);

  // 이미지 크기가 제각각이라 글자 크기를 가로폭에 비례시킨다
  const fontSize = Math.max(14, Math.round(canvas.width * 0.045));
  const padding = Math.round(fontSize * 0.4);

  ctx.save();
  ctx.font = `bold ${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`;
  ctx.textBaseline = "alphabetic";
  ctx.textAlign = "left";

  const textWidth = ctx.measureText(text).width;
  const boxWidth = textWidth + padding * 2;
  const boxHeight = fontSize + padding * 2;
  const boxX = canvas.width - boxWidth - padding;
  const boxY = canvas.height - boxHeight - padding;

  ctx.fillStyle = "rgba(0, 0, 0, 0.55)";
  ctx.fillRect(boxX, boxY, boxWidth, boxHeight);

  ctx.fillStyle = "#ffffff";
  ctx.fillText(text, boxX + padding, boxY + padding + fontSize * 0.8);
  ctx.restore();
}
